import {
  setPromotionGrouping,
  setSelectedAm,
  setSelectedPromotionTarget,
} from "@/features/dataTableSlice";
import { ButtonSendTheme } from "@/styles/mui/tableListTheme";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { LoadingButton } from "@mui/lab";
import { Autocomplete } from "@mui/material";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { GridToolbar, GridToolbarContainer } from "@mui/x-data-grid";
import _ from "lodash";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
export default function PromotionTargetDataTableToolBar(props) {
  const { fetchData, loading, promotionTargetData, amOptions } = props;
  const dispatch = useDispatch();
  const options = _.map(promotionTargetData, (d) => {
    return {
      label: `${moment(d.date).format("YYYY-MM-DD")} - ${d.name}`,
      id: d.id,
      type: d.type,
    };
  });
  const selectedAm = useSelector((state) => state.dataTable.selectedAm);
  const selectedPromotionTarget = useSelector(
    (state) => state.dataTable.selectedPromotionTarget
  );
  const promotionGrouping = useSelector(
    (state) => state.dataTable.promotionGrouping
  );

  const handleAMChange = (e) => {
    dispatch(setSelectedAm({ value: e.target.value }));
  };
  const handlePromotionTargetChange = (e, value) => {
    dispatch(setSelectedPromotionTarget({ value }));
  };

  const handlePromotionGroupingChange = (e) => {
    dispatch(setPromotionGrouping({ value: e.target.value }));
  };
  return (
    <>
      <GridToolbarContainer>
        <Box>
          <FormControl sx={{ m: 1, width: 300 }}>
            <Autocomplete
              value={selectedPromotionTarget}
              getOptionKey={(option) => option.id}
              options={options}
              onChange={handlePromotionTargetChange}
              renderInput={(params) => (
                <TextField {...params} label="推廣日名稱" />
              )}
            />
          </FormControl>
          <FormControl sx={{ m: 1, width: 200 }}>
            <InputLabel id="group-by-label">AM</InputLabel>
            <Select
              labelId="am-select-label"
              id="am-select"
              value={selectedAm}
              label="am"
              multiple
              onChange={handleAMChange}
              renderValue={(selected) =>
                selected.length === amOptions.length
                  ? "所有AM"
                  : `已選擇${selected.length}個`
              }
              input={<OutlinedInput label="AM" />}
            >
              {_.map(amOptions, (item, index) => (
                <MenuItem key={index} value={item.am_id}>
                  <Checkbox
                    checked={
                      selectedAm.find((d) => d === item.am_id) !== undefined
                    }
                  />
                  <ListItemText primary={item.am_name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, width: 200 }}>
            <InputLabel id="group-by-label">分類</InputLabel>
            <Select
              labelId="am-select-label"
              id="am-select"
              value={promotionGrouping}
              onChange={handlePromotionGroupingChange}
              input={<OutlinedInput label="分類" />}
            >
              <MenuItem value="shop">店鋪</MenuItem>
              <MenuItem value="am">AM</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ m: 2 }}>
            <ThemeProvider theme={ButtonSendTheme}>
              <LoadingButton
                size="small"
                endIcon={<SearchOutlinedIcon fontSize="small" />}
                loadingPosition="end"
                disabled={!selectedPromotionTarget}
                onClick={async () => {
                  await fetchData(
                    selectedPromotionTarget,
                    selectedAm,
                    promotionGrouping
                  );
                }}
                variant="contained"
                loading={loading}
              >
                搜尋
              </LoadingButton>
            </ThemeProvider>
          </FormControl>
        </Box>
      </GridToolbarContainer>
      <GridToolbarContainer>
        <GridToolbar
          csvOptions={{
            utf8WithBom: true,
          }}
        />
      </GridToolbarContainer>
    </>
  );
}
